// @flow

import React from "react";

import { domainConfig } from "../../domain-config";

export function CanWeHelp() {
    return (
        <div className="info-block-contact">
            <h4 className="info-block-contact__header">Can we help you?</h4>
            <ul className="info-block-contact__contact-options">
                {domainConfig.help_major_call_us_visible && (
                    <li>
                        <a
                            href="tel:1800032566"
                            className="info-block-contact__contact-option"
                        >
                            <i className="zmdi zmdi-phone" />
                            Call us on 1800 032 566
                        </a>
                    </li>
                )}
                {domainConfig.help_major_contact_us_visible && (
                    <li>
                        <a
                            href={domainConfig.help_contact_us_link}
                            className="info-block-contact__contact-option"
                        >
                            <i className="zmdi zmdi-phone" />
                            Contact us
                        </a>
                    </li>
                )}
                <li>
                    <a
                        href={domainConfig.help_store_finder_link}
                        className="info-block-contact__contact-option"
                    >
                        <i className="zmdi zmdi-help" />
                        Find your local store
                    </a>
                </li>
            </ul>
            <ul className="info-block-contact__useful-links">
                <li>
                    <h4 className="info-block-contact__header">
                        Apply for a trade account
                    </h4>

                    <b>
                        <a
                            href={
                                domainConfig.help_apply_online_trade_credit_account_link
                            }
                        >
                            {domainConfig.help_apply_text}
                        </a>
                    </b>
                </li>
            </ul>
            <ul className="info-block-contact__useful-links">
                {domainConfig.help_contact_us_visible && (
                    <li>
                        <a
                            href={domainConfig.help_contact_us_link}
                            className="info-block-contact__useful-link"
                        >
                            Contact us
                        </a>
                    </li>
                )}
                {domainConfig.help_faq_visible && (
                    <li>
                        <a
                            href="https://help.reece.com.au/hc/en-us"
                            className="info-block-contact__useful-link"
                        >
                            FAQs
                        </a>
                    </li>
                )}
                <li>
                    <a
                        href="/warranties"
                        className="info-block-contact__useful-link"
                    >
                        Product quality guarantee
                    </a>
                </li>
                <li>
                    <a
                        href={domainConfig.help_term_and_cond_link}
                        className="info-block-contact__useful-link"
                    >
                        Terms & conditions
                    </a>
                </li>
            </ul>
        </div>
    );
}
